import { callApi } from '../utils';

// All requests go through the interceptor-enabled callApi so that writes pick up
// the global approval-required / 2fa-required handling.

export const getMenu = () => callApi('/config/facade');

export const getSubject = (section, subject) =>
  callApi(`/config/sections/${section}/subjects/${subject}`);

export const saveSubject = (section, subject, changes) =>
  callApi(
    `/config/sections/${section}/subjects/${subject}`,
    { data: changes },
    'post'
  );

export const updateItem = (key, value) =>
  callApi(`/config/${key}`, { value }, 'patch');

export default { getMenu, getSubject, saveSubject, updateItem };
